import React, { useMemo } from 'react'
import { Translation } from 'react-i18next'
// import Button from '@material-ui/core/Button'
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableRow,
  withStyles
} from '@material-ui/core'
import {
  Form,
  // Field,
  useForm,
  useFieldArray,
  WatchField,
  useWatch
  // useWatch
} from '../../form'
import { Controller } from 'react-hook-form'
import RichTextEditorComponent from '../employer/lightEntrepreneurs/richTextEditor.component'
import BasicDateCalendar from '../../utils/DateCalendar.utils'
import TimeInputTableComponent from './timeInputTable.component'
import classNames from 'classnames'
import { calculateSum } from '../invoice/invoiceInputTable.component'
import SumField from '../invoice/sumField.component'
import { timeReportValidate } from '../../containers/validate'
import moment from 'moment'

const styles = () => ({
  root: {
    width: '100%',
    overflowX: 'auto',
    '&::-webkit-scrollbar': {
      width: '12px !important',
      webkitOverflowScrolling: 'auto !important'
    },

    '&::-webkit-scrollbar-track': {
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3) !important',
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important'
    },

    '&::-webkit-scrollbar-thumb': {
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important',
      background: '#41617D !important',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.5) !important'
    },

    '&::-webkit-scrollbar-thumb:window-inactive': {
      background: '#41617D !important'
    }
  },
  textField: {
    fontWeight: 500,
    color: '#000000'
  },
  resize: {
    fontSize: '15px'
  },
  tablecell2: {
    border: '1px solid grey',
    padding: '5px',
    fontWeight: 500,
    color: '#000000',
    fontSize: '13px',
    fontWeight: 'bold'
  }
})

export const dateTimeRowDefaultValues = {
  date: new Date(),
  startTime: '08:00',
  endTime: '16:00',
  totalHour: '',
  amount: '',
  additionalInfo: '',
  totalAmount: 0
}

const defaultValues = {
  task_description: '',
  dateTimeRows: [dateTimeRowDefaultValues],
  totalAmount: 0,
  selectedDate: null
}

const TimeReportForm = ({
  classes,
  addJournalDetail,
  isEditJournal,
  cancelJournalEdit,
  updateJournalDetail
}) => {
  const form = useForm({
    name: 'timeReport',
    onSubmit: onSubmit,
    defaultValues: defaultValues,
    validator: timeReportValidate,
    resetOnSubmit: true
  })
  const {
    control,
    clearErrors,
    formState: { errors }
  } = form
  const rowState = useFieldArray({ name: 'dateTimeRows', control })

  const { fields: rowFields } = rowState
  function onSubmit(values) {
    if (!isEditJournal) {
      addJournalDetail(values)
    } else {
      updateJournalDetail(values)
    }
  }
  function removeRow(index) {
    rowState.remove(index)
  }

  const rowsData = useWatch({
    fields: ['dateTimeRows'],
    control: control
  })

  function addRow(value) {
    const newDate = new Date(value)
    const dateTimeRowCopy = {
      ...dateTimeRowDefaultValues,
      date: newDate,
      amount: rowsData.dateTimeRows[0]?.amount,
      ...(isEditJournal && { journal_itemid: -1 })
    }
    rowState.append(dateTimeRowCopy)
  }

  function addExtraDateRow() {
    const currentDateRows = rowsData.dateTimeRows
    if (!currentDateRows || currentDateRows.length === 0) {
      // Fallback if empty: just add today
      return addRow(new Date())
    }

    // Get latest date in the current date rows
    const lastDateStr = currentDateRows.reduce((latest, row) => {
      const current = new Date(row.date)
      return current > new Date(latest) ? current : latest
    }, currentDateRows[0].date)
    // Add 1 day
    // const nextDate = new Date(lastDateStr)
    // nextDate.setDate(nextDate.getDate() + 1)

    addRow(new Date(lastDateStr))
  }

  function setValue(name, value) {
    form?.setValue(name, value)
  }

  const watchFields = getWatchFields(rowFields, 'totalAmount')

  const selectedDate = useMemo(
    () =>
      rowsData.dateTimeRows.map((el) => moment(el.date).format('YYYY-MM-DD')),
    [rowsData.dateTimeRows]
  )
  // console.log('huong datatime row', selectedDate)

  // KAS-883 Sort date time rows by date
  React.useEffect(() => {
    const currentRows = rowsData.dateTimeRows || []
    const sortedRows = [...currentRows].sort(
      (a, b) => new Date(a.date) - new Date(b.date)
    )

    // Check if sorting actually changed the order
    const isSameOrder = currentRows.every(
      (row, index) => row.date === sortedRows[index]?.date
    )

    if (!isSameOrder) {
      setValue('dateTimeRows', sortedRows)
    }
  }, [rowState.dateTimeRows, setValue])

  return (
    <Translation>
      {(t) => (
        <div className="row">
          <div className="dashboard-content-header">
            <div className="col-xs-12 col-sm-12 col-lg-12">
              <div className="panel panel-default">
                <div className="row">
                  <div
                    className="dashboard-content-header"
                    style={{ paddingTop: '20px' }}
                  >
                    <h1>
                      {isEditJournal ? t('workshift.h1d') : t('workshift.h1c')}
                    </h1>
                  </div>
                </div>
                <div className="panel-body pd-0">
                  <div style={{ padding: '16px' }}>
                    <Form {...form}>
                      <div>
                        <p
                          style={
                            errors.task_description ? { color: 'red' } : {}
                          }
                        >
                          <b>{t('ws_journal.fld1')}</b>
                        </p>
                        <div
                          style={{
                            border: errors.task_description
                              ? '1px solid red'
                              : ''
                          }}
                        >
                          <Controller
                            render={({ field: { value, onChange } }) => {
                              const handleEditorChange = (editorValue) => {
                                onChange(editorValue)
                              }
                              return (
                                <RichTextEditorComponent
                                  value={value}
                                  onEditorChange={handleEditorChange}
                                  height="200px"
                                />
                              )
                            }}
                            name="task_description"
                            control={control}
                          />
                        </div>
                      </div>
                      <div className="row" style={{ padding: '16px' }}>
                        <div
                          className="col-xs-12 col-sm-12 col-md-12 col-lg-3"
                          style={{
                            padding: '0px 5px 0px 5px'
                          }}
                        >
                          <div
                            style={{
                              border: '1px solid grey',
                              padding: 0,
                              display: 'inline-block'
                            }}
                          >
                            <BasicDateCalendar
                              disabledDates={[]}
                              onChange={addRow}
                              selectedDates={selectedDate}
                            />
                          </div>
                          <div>
                            <span
                              style={{
                                color: '#F67131',
                                fontSize: '13px',
                                fontWeight: 500
                              }}
                            >
                              <i>{t('ws_journal.p')}</i>
                            </span>
                          </div>
                        </div>
                        <div
                          className="col-xs-12 col-sm-12 col-md-12 col-lg-9"
                          style={{
                            padding: '0px 5px 0px 5px'
                          }}
                        >
                          <div
                            style={{
                              border: '1px solid grey',
                              padding: 0,
                              minHeight: '500px',
                              position: 'relative'
                            }}
                            className={classes.root}
                          >
                            <div style={{ paddingBottom: 55 }}>
                              <TimeInputTableComponent
                                control={control}
                                fields={rowFields}
                                addRow={addRow}
                                removeRow={removeRow}
                                setValue={setValue}
                                isEditJournal={isEditJournal}
                                errors={errors}
                                addExtraDateRow={addExtraDateRow}
                                watchRowsData={rowsData.dateTimeRows}
                                clearErrors={clearErrors}
                              />
                            </div>
                            <div
                              style={{
                                position: 'absolute',
                                bottom: 0,
                                width: '100%'
                              }}
                            >
                              <div className={classes.root}>
                                <Table>
                                  <TableBody>
                                    <TableRow>
                                      <TableCell className={classes.tablecell2}>
                                        <div
                                          style={{ display: 'flex' }}
                                          className="pull-right"
                                        >
                                          <div
                                            style={{
                                              marginTop: 'auto',
                                              padding: '8px'
                                            }}
                                          >
                                            {t('workshift.totalAmount')}
                                          </div>
                                          <div style={{ width: '140px' }}>
                                            {' '}
                                            <WatchField
                                              fields={watchFields.totalSum}
                                              control={control}
                                            >
                                              {(fields) => (
                                                <SumField
                                                  name="totalAmount"
                                                  control={control}
                                                  setValue={setValue}
                                                  watchValue={calculateSum(
                                                    fields
                                                  )}
                                                  className={classNames(
                                                    classes.textField,
                                                    classes.resize
                                                  )}
                                                />
                                              )}
                                            </WatchField>
                                          </div>
                                        </div>
                                      </TableCell>
                                    </TableRow>
                                  </TableBody>
                                </Table>
                              </div>
                            </div>
                          </div>
                          <div
                            className="pull-right"
                            style={{ paddingTop: 30 }}
                          >
                            {isEditJournal ? (
                              <ul
                                className="nav nav-pills"
                                style={{ marginRight: 0 }}
                              >
                                <li>
                                  <Button
                                    variant="outlined"
                                    onClick={() => {
                                      cancelJournalEdit()
                                      form.reset()
                                    }}
                                  >
                                    {t('workshift.btn4')}
                                  </Button>
                                </li>
                                <li>
                                  <Button variant="contained" type="submit">
                                    {t('workshift.btn9')}
                                  </Button>
                                </li>
                              </ul>
                            ) : (
                              <Button variant="contained" type="submit">
                                {t('workshift.btn6')}
                              </Button>
                            )}
                          </div>
                        </div>
                      </div>
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </Translation>
  )
}

const getWatchFields = (fields, totalField) => {
  const totalSum = []
  for (let i = 0; i < fields.length; i++) {
    totalSum.push(`dateTimeRows.${i}.${totalField}`)
  }
  return { totalSum }
}

export default withStyles(styles)(TimeReportForm)
